// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"c0706fe5","115":"7770f80e","126":"ea46068a","155":"9d8f47c7","188":"07bfd1ca","198":"01a51a6a","280":"d6f401b2","380":"cf9aa697","414":"8853cb8b","640":"bc9259e6","641":"5eba6d9d","721":"69c866bb","775":"3243e871","970":"9f42c17e"}[chunkId] + ".chunk.css";
};